export var ConstructionTypeEnum;
(function (ConstructionTypeEnum) {
    ConstructionTypeEnum["HeavySingleLayerWall"] = "HeavySingleLayerWall";
    ConstructionTypeEnum["HeavyMultiLayerWallFacingOneSide"] = "HeavyMultiLayerWallFacingOneSide";
    ConstructionTypeEnum["HeavySingleLayerWallFacingBothSide"] = "HeavySingleLayerWallFacingBothSide";
    ConstructionTypeEnum["HeavySingleLayerWallFacingOneSide"] = "HeavySingleLayerWallFacingOneSide";
    ConstructionTypeEnum["HeavySingleLayerWallSoundproofingOneSide"] = "HeavySingleLayerWallSoundproofingOneSide";
    ConstructionTypeEnum["HeavySingleLayerWallSoundproofingBothSide"] = "HeavySingleLayerWallSoundproofingBothSide";
    ConstructionTypeEnum["HeavyMultiLayerWall"] = "HeavyMultiLayerWall";
    ConstructionTypeEnum["HeavyMultiLayerWallFacingBothSide"] = "HeavyMultiLayerWallFacingBothSide";
    ConstructionTypeEnum["HeavyMultiLayerWallSoundproofingOneSide"] = "HeavyMultiLayerWallSoundproofingOneSide";
    ConstructionTypeEnum["HeavyMultiLayerWallSoundproofingBothSide"] = "HeavyMultiLayerWallSoundproofingBothSide";
    ConstructionTypeEnum["FramePartitionSingle"] = "FramePartitionSingle";
    ConstructionTypeEnum["FramePartitionDouble"] = "FramePartitionDouble";
    ConstructionTypeEnum["HeavySingleWallFacing"] = "HeavySingleWallFacing";
})(ConstructionTypeEnum || (ConstructionTypeEnum = {}));
export var RuConstructionTypesMap = {
    HeavySingleLayerWall: 'Тяжелая однослойная стена',
    HeavySingleLayerWallFacingOneSide: 'Тяжелая однослойная стена + облицовка с одной стороны',
    HeavySingleLayerWallFacingBothSide: 'Тяжелая однослойная стена + облицовка с двух сторон',
    HeavySingleLayerWallSoundproofingOneSide: 'Тяжелая однослойная стена + звукоизоляционная панель с одной стороны',
    HeavySingleLayerWallSoundproofingBothSide: 'Тяжелая однослойная стена + звукоизоляционная панель с двух сторон',
    HeavyMultiLayerWall: 'Тяжелая многослойная стена',
    HeavyMultiLayerWallFacingOneSide: 'Тяжелая многослойная стена + облицовка с одной стороны',
    HeavyMultiLayerWallFacingBothSide: 'Тяжелая многослойная стена + облицовка с двух сторон',
    HeavyMultiLayerWallSoundproofingOneSide: 'Тяжелая многослойная стена + звукоизоляционная панель с одной стороны',
    HeavyMultiLayerWallSoundproofingBothSide: 'Тяжелая многослойная стена + звукоизоляционная панель с двух сторон',
    FramePartitionSingle: 'Каркасная перегородка (1 каркас)',
    FramePartitionDouble: 'Каркасная перегородка (2 каркаса)',
    HeavySingleWallFacing: 'Тяжелая обнослойная стена + облицвока',
};
export var RuConstructionTypesSelectValues = [
    { label: 'Тяжелая однослойная стена', value: ConstructionTypeEnum.HeavySingleLayerWall },
    {
        label: 'Тяжелая однослойная стена + облицовка с одной стороны',
        value: ConstructionTypeEnum.HeavySingleLayerWallFacingOneSide,
    },
    {
        label: 'Тяжелая однослойная стена + облицовка с двух сторон',
        value: ConstructionTypeEnum.HeavySingleLayerWallFacingBothSide,
    },
];
